/**
 * 기기 메모리까지 고려하여 하드웨어 동시성 여유 개수.
 *
 * 주로 이미지 처리 시에 사용합니다.
 */
export const getHardwareConcurrencyWithMemory = () => {
  // NOTE: 0.25, 0.5, 1, 2, 4, 8 등급으로 나옴.
  const deviceMemory =
    'deviceMemory' in window.navigator && typeof window.navigator.deviceMemory === 'number'
      ? window.navigator.deviceMemory
      : 2;

  const concurrencyByMemory = Math.floor(deviceMemory <= 4 ? deviceMemory / 2 : 1000);
  const concurrencyByCore = Math.floor(
    window.navigator.hardwareConcurrency <= 4
      ? window.navigator.hardwareConcurrency / 2
      : window.navigator.hardwareConcurrency - 2, // NOTE: 코어 여유 두기
  );

  return Math.max(1, Math.min(concurrencyByMemory, concurrencyByCore));
};
